import { Icon } from '@clientbase/clientbase-library'
import { IconButton, Tooltip } from '@mui/material'
import { useRouter } from 'next/router'

import { theme } from 'styles/theme'

import { useChangelog } from '../../context/ChangelogContext'
import * as S from './ChangelogBellButton.styles'

export default function ChangelogBellButton() {
  const router = useRouter()
  const { unreadCount: count } = useChangelog()

  const handleClick = () => {
    router.push('/novidades')
  }

  return (
    <S.Wrapper>
      <Tooltip title="Novidades">
        <IconButton onClick={handleClick} aria-label="Novidades">
          <S.StyledBadge
            badgeContent={count > 99 ? '99+' : count}
            invisible={count === 0}
          >
            <Icon
              height="21px"
              width="21px"
              icon="faBullhorn"
              colorSX={theme.palette.neutral[400]}
            />
          </S.StyledBadge>
        </IconButton>
      </Tooltip>
    </S.Wrapper>
  )
}
